import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Components } from '@firedesktop/react-base';

import _BaseActions from '../../../actions/_BaseActions';
import CookiesActions from '../../../actions/Authentication/CookiesActions';
import * as Types from '../../../Config/Types';

export default function LoginOIDCCallback() {
    const configuration = useSelector((state: Types.InitialState_TYPE) => state.configuration);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { updateAppState } = _BaseActions();
    const { cookie_set } = CookiesActions();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const data = params.get('data');

        if (data) {
            try {
                const jsonStr = decodeURIComponent(data);
                const loginResponse: Types.AuthenticationState_TYPE = JSON.parse(jsonStr);

                if (configuration.authentication?.localStorageName) {
                    localStorage.setItem(configuration.authentication.localStorageName, JSON.stringify(loginResponse));
                }

                if (configuration.authentication?.cookies) {
                    cookie_set(loginResponse.token, 1);
                }

                dispatch(updateAppState('authentication', loginResponse));} catch {
                    console.error('Errore parsing loginResponse dal callback');
            }
        }

        navigate('/'); // Redirect finale dopo la login
    }, [dispatch, location.search, navigate, configuration]);

    return null;
}
